<template>
  <zj-layout-container>
    <zj-layout-main style="padding:0rem 0rem;">
      <div class="zj-layout-main-content scrollable" style="padding:0rem 0rem;">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="editable">
          <el-checkbox-group
            @change="handleCheckedChange"
            v-model="Usersids"
            class="zj-user-list"
          >
            <el-checkbox
              v-for="item in UsersOptions"
              :key="item.BookId"
              :label="item.BookId"
              :value="item.BookId"
            >{{item.PersonName}}</el-checkbox>
          </el-checkbox-group>
        </el-form>
      </div>
    </zj-layout-main>
    
  </zj-layout-container>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "ZjUserListControl",
  controller: "UI",
  action: "UserListControl",
  components: {},
  props: {
    ResourceTypeId: { type: String },
    PersonOrgianiztionId: { type: String },
    InputUsersids: { type: Array },
  },
  data() {
    return {
      UsersOptions: [],
      Usersids: [],
      CheckedUserItems: [],
    };
  },
  created: function () {
    if (this.ResourceTypeId != "" && this.PersonOrgianiztionId != "") {
      this.GetUserData();
    }
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    showLoading(text) {
      this.$emit('loading', text);
    },
    hideLoading() {
      this.$emit('loadingFinish');
    },
    GetUserData() {
      this.showLoading('加载中...');
      new MyApis.AddressbookApi()
        .FindByConditions({
          ResourceTypeId: this.ResourceTypeId,
          PersonOrgianiztionId: this.PersonOrgianiztionId,
        })
        .then((r) => {
          var data = r.data.Data;
          if (data) {
            this.UsersOptions = data;
          }
          this.hideLoading();
        })
        .catch((e) => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.hideLoading();
        });
    },
    handleCheckedChange(value) {
      let that = this;
      this.Usersids = value;

      this.CheckedUserItems = this.UsersOptions.filter((item) => {
        return that.Usersids.includes(item.BookId);
      }).map((item) => {
        return {
          PersonName: item.PersonName,
          PhoneNum: item.PhoneNum,
          BookId: item.BookId,
        };
      });
    },
    setDefaultCheckItems() {
      let that = this;
      if (
        this.InputUsersids &&
        this.InputUsersids.length > 0 &&
        this.UsersOptions &&
        this.UsersOptions.length > 0
      ) {
        this.InputUsersids.forEach((item) => {
          if (
            that.UsersOptions.some((a) => {
              return a.BookId == item.ReceiverId;
            })
          ) {
            that.Usersids.push(item.ReceiverId);
          }
        });
      }
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    InputUsersids: function () {
      this.setDefaultCheckItems();
    },
    UsersOptions: function () {
      this.setDefaultCheckItems();
    },
  },
};
</script>